/**
 * friendshipBracelets — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const friendshipBraceletsPack: ToilePack = {
    slug: 'friendship-bracelets',
    category: 'bracelets',
    name: 'Friendship bracelet patterns',
    tagline: tagline('patterns', 'patterns', 'treatments'),
    chips: chips('patterns', 'treatments'),
    ratio: SQUARE,
    readings: [
        {key: 'chevron', label: 'Chevron', subject: 'bands of color meeting in a V down the center'},
        {key: 'diamond', label: 'Diamond wave', subject: 'outlined diamonds linked in a running chain'},
        {key: 'heart', label: 'Heart band', subject: 'a row of small hearts repeating along the length'},
    ],
    styles: [
        {key: 'chart', label: 'Knot chart', style: 'staggered grid of knot cells, strand paths drawn', palette: 'flat colors on pure white', framing: 'flat, from directly above'},
        {key: 'rendered', label: 'Finished bracelet', style: 'close macro of embroidery floss knots', palette: 'knot texture and floss sheen', framing: 'flat on a plain pale surface'},
        {key: 'summer', label: 'Summer palette', style: 'several finished bracelets side by side', palette: 'neon coral, turquoise, lime and yellow', framing: 'laid in a row, from above'},
    ],
    directions: ['a candy stripe instead', 'in black and white', 'wider, more strands'],
}
